module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Tim Hetherington spent his early years in the north of England. After graduating from Sussex University, he worked as a civil servant, followed by forty years in social services, first in England and then in Australia. After retiring, Tim moved to Thailand where he has devoted his time to his life-long passion for writing. The inspiration for this book was his grandmother’s frequently spoken claim that the Hetheringtons were descended from a long line of highwaymen.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("This novel contains contemporaneous historical material concerning a certain highwayman named William Surtees Hetherington, who may or may not be one of his forebears.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Tim has had two books published in recent years:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('em', [_vm._v("Symmetry")]), _vm._v(" (2021), a book of short stories based on his experiences in child protection work. Published under the pseudonym Margaret Hughes.")])]), _vm._v(" "), _c('li', [_c('p', [_c('em', [_vm._v("The Life and Loves of Saint Columba")]), _vm._v(" (2022).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256644c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0